<template>
	<div :id="blok._uid" class="md:mx-md 2xl:mx-0">
		<div class="mb-sm flex justify-center">
			<p class="font-prenton-cond text-4xl font-bold uppercase md:text-8xl">
				{{ blok.title }}
			</p>
		</div>

		<div
			class="col-span-full grid grid-cols-2 gap-8 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-6"
		>
			<div
				v-for="(content, index) in blok.content"
				:key="index"
				class="flex h-full items-center justify-center"
			>
				<v-storyblok-component :blok="content" class="items-center" />
			</div>
		</div>

		<div v-if="url !== '#'" class="mt-xl flex justify-center md:mt-xl">
			<nuxt-link :to="url" :aria-label="blok.link_title">
				<p class="font-sans underline decoration-solid hover:no-underline">
					{{ blok.link_title }}
				</p>
			</nuxt-link>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

import formatSbUrl from "@pkg/shared/utils/format-sb-url";

const properties = defineProps<{
	blok: Extract<
		BlokComponent,
		{component: "sb-brands-grid" | "sb-brands-grid-brand"}
	>;
}>();

const url = computed(() => formatSbUrl(properties.blok.link));
</script>
